export default [
  // 领取课程或者票券
  {
    path: '/ticket-and-present',
    name: 'ticket-and-present',
    component: _ => import("@/pages/ticket-and-present/index.vue"),
    meta: {
      title: '领取票劵或|课程'
    },
  },
  {
    path: '/ticket-info',
    name: 'ticket-info',
    component: _ => import("@/pages/ticket-and-present/ticket-info.vue"),
    meta: {
      title: '领取票劵'
    },
  },
  {
    path: '/qrCore',
    name: 'qrCore',
    component: _ => import("@/pages/ticket-and-present/qrCore.vue"),
    meta: {
      title: ''
    },
  },
  {
    path: '/receive',
    name: 'receive',
    redirect: to => {
      return { path: '/ticket-and-present', query: { ...to.query, jumpType: '', title: '领取课程' } }
    },
    meta: {
      title: '领取课程'
    },
  },
  {
    path: "/complimentary",
    name: 'complimentary',
    redirect: to => {
      return { path: '/ticket-and-present', query: { ...to.query, jumpType: 1, title: '领取票券' } }
    },
  },
]